/**
Copyright (c) 2023, 2024, 2025 Amica Corp.
All rights reserved.

This source code, resulting binary forms, and associated documentation
(the "Software") may only be used, modified, or distributed, with or
without modification, under the terms of a written license agreement
with Amica Corp. (the "License"). All rights to manufacture, use,
redistribute, or sell anything described herein, in whole or in part,
are granted only as explicitly permitted by such License. The receipt
or possession of the Software does not convey any of these rights.

This Software is provided "AS IS," WITHOUT WARRANTY OF ANY KIND, express
or implied, including but not limited to the implied warranties of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.

For additional terms, see https://amica.cloud/software-copyright/
 */

import { withTheme } from '@emotion/react';
import { useSelector } from 'react-redux';
import { selectScenarios } from 'modules/scenario/selectors';
import { useEffect, useState } from 'react';
import { DataGrid } from '@mui/x-data-grid';
import { TABLE_HEADER_FONT_COLOR } from 'modules/common/constants/style';
import { Grid, Chip } from '@mui/material';
import { isEmpty } from 'modules/common/helpers/object';
/**
 * Data grid to display all registered scenarios
 * @param {*} param0
 * @returns
 */
const columnVisibilityModel = {
  id: false,
};
/**
 * Column names for the data grid is defined here
 */
const columns = [
  {
    field: 'id',
    headerName: 'ID',
    headerClassName: 'super-app-theme--header',
    flex: 1,
  },
  {
    field: 'name',
    headerName: 'Scenario Name',
    headerClassName: 'super-app-theme--header',
    flex: 1,
  },
  {
    field: 'description',
    headerName: 'Description',
    headerClassName: 'super-app-theme--header',
    flex: 3,
  },
  {
    field: 'visuals',
    headerName: 'Visuals',
    headerClassName: 'super-app-theme--header',
    renderCell: (params) =>
      params.value?.map((v) => (
        <Chip
          key={v.displayName} // unique key
          label={v.displayName} // show the actual displayName
          size="small"
          sx={{ mr: 0.5, mb: 0.5 }}
        />
      )),
    flex: 2,
  },
];
/**
 * Data grid to display all registered scenarios
 * @param {*} param0
 * @returns
 */
const ScenarioTableView = ({ isShow, setSelectedScenario }) => {
  const scenarios = useSelector(selectScenarios);
  //
  const [filteredScenarios, setFilteredScenarios] = useState([]);
  //
  useEffect(() => {
    if (!isEmpty(scenarios)) {
      const formattedScenario = scenarios?.map((scenario) => ({
        id: scenario?.id,
        name: scenario?.name,
        description: scenario?.description,
        visuals: scenario?.visuals,
      }));
      setFilteredScenarios(formattedScenario);
    }
  }, [scenarios]);
  //
  const onSelectedRowChange = (id) => {
    if (id?.length) {
      setSelectedScenario(scenarios.find((scenario) => scenario?.id === id?.[0]));
      isShow(true);
    }
  };
  //
  return (
    <Grid container sx={{ height: 600 }}>
      <DataGrid
        sx={{
          '& .super-app-theme--header': {
            backgroundColor: 'white',
            color: TABLE_HEADER_FONT_COLOR,
          },
          '& .MuiDataGrid-main': {
            backgroundColor: 'white',
          },
          '.MuiDataGrid-footerContainer': {
            backgroundColor: 'white',
          },
        }}
        columnVisibilityModel={columnVisibilityModel}
        rowHeight={50}
        rows={filteredScenarios || []}
        columns={columns}
        onSelectionModelChange={onSelectedRowChange}
        columnGroupingModel={[
          {
            groupId: 'Visuals',
            children: [{ field: 'filters' }, { field: 'name' }],
          },
        ]}
      />
    </Grid>
  );
};
//
export default withTheme(ScenarioTableView);
